<ng-content></ng-content>
<div class="a3l-ui-segment__indicator" #indicator></div>
